import { TextInput, Button, Group, Stack } from '@mantine/core';
import { useForm } from '@mantine/form';
import type { Shop } from '@/types/company';

interface ShopFormProps {
  initial: Shop | null;
  onSave: (data: Omit<Shop, 'id' | 'companyId'>) => void;
  onCancel: () => void;
  loading: boolean;
}

export function ShopForm({ initial, onSave, onCancel, loading }: ShopFormProps) {
  const form = useForm({
    initialValues: {
      address: initial?.address ?? { street: '', houseNumber: '', postalCode: '', city: '', country: 'Deutschland' },
      email: initial?.email ?? '',
      phone: initial?.phone ?? '',
    },
    validate: {
      email: (v) => (/^\S+@\S+$/.test(v) ? null : 'Gültige E-Mail erforderlich'),
      address: {
        street: (v) => (v.trim() ? null : 'Straße ist erforderlich'),
        postalCode: (v) => (v.trim() ? null : 'PLZ ist erforderlich'),
        city: (v) => (v.trim() ? null : 'Stadt ist erforderlich'),
      },
    },
  });

  return (
    <form onSubmit={form.onSubmit(onSave)}>
      <Stack gap="sm">
        <Group grow>
          <TextInput label="Straße" required {...form.getInputProps('address.street')} />
          <TextInput label="Hausnr." w={100} {...form.getInputProps('address.houseNumber')} />
        </Group>
        <Group grow>
          <TextInput label="PLZ" required {...form.getInputProps('address.postalCode')} />
          <TextInput label="Stadt" required {...form.getInputProps('address.city')} />
        </Group>
        <TextInput label="Land" {...form.getInputProps('address.country')} />
        <TextInput label="E-Mail" required {...form.getInputProps('email')} />
        <TextInput label="Telefon" {...form.getInputProps('phone')} />
        <Group justify="flex-end">
          <Button variant="default" onClick={onCancel}>Abbrechen</Button>
          <Button type="submit" loading={loading}>Speichern</Button>
        </Group>
      </Stack>
    </form>
  );
}
